(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instyle-account"]) return;
  try {
    
  (function () {
    function initAccountTabs(root) {
      var tabs = root.querySelectorAll('[data-acct-tab]');
      var panels = root.querySelectorAll('[data-acct-panel]');
      if (!tabs.length) return;
      function show(name) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-acct-tab') === name;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-acct-panel') !== name;
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var name = t.getAttribute('data-acct-tab');
          show(name);
          if (history.replaceState) history.replaceState(null, '', name === 'details' ? '#details' : location.pathname);
        });
      });
      show(location.hash === '#details' ? 'details' : 'orders');
    }
    document.querySelectorAll('.instyle-acct').forEach(initAccountTabs);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.instyle-acct').forEach(initAccountTabs);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instyle-shop-the-room"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scenes = document.querySelectorAll('[data-scene]');
    Array.prototype.forEach.call(scenes, init);

    function init(scene) {
      var stage = scene.querySelector('[data-scene-stage]');
      if (!stage) return;
      var spots = Array.prototype.slice.call(stage.querySelectorAll('[data-spot]'));
      var cards = Array.prototype.slice.call(scene.querySelectorAll('[data-scene-card]'));
      var open = null;
      var items = [];

      function cardFor(spot) {
        var id = spot.getAttribute('data-spot');
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].getAttribute('data-scene-card') === id) return cards[i];
        }
        return null;
      }

      function place(card, spot) {
        var x = parseFloat(spot.getAttribute('data-x')) || 0;
        var y = parseFloat(spot.getAttribute('data-y')) || 0;
        card.setAttribute('data-side', x > 50 ? 'left' : 'right');
        card.setAttribute('data-vert', y > 58 ? 'above' : 'below');
      }

      // Keep a hover label inside the picture: work out where it would sit,
      // centred on its dot, and slide it back by the overhang (plus a small
      // margin). Computed from the dot's centre and the label's LAYOUT width,
      // never from the label's own rectangle: that rectangle carries the
      // transform, which is mid-transition whenever the label is fading, so
      // it would measure a label still sliding from its last position.
      // A label that is not laid out (phones: display none) is 0 wide and is
      // left be.
      function fitTip(spot) {
        var tip = spot.querySelector('.instyle-scene__tip');
        var dot = spot.querySelector('[data-dot]');
        if (!tip || !dot) return;
        var w = tip.offsetWidth;
        if (!w) return;
        var d = dot.getBoundingClientRect();
        var s = stage.getBoundingClientRect();
        // A zoomed homepage (instyle-page-zoom) measures rectangles in screen
        // pixels but lays the label out in the section's own pixels: work in
        // screen pixels, then convert the shift back.
        var z = stage.offsetWidth ? s.width / stage.offsetWidth : 1;
        if (!z) z = 1;
        w = w * z;
        var cx = d.left + d.width / 2;
        var pad = 8;
        var shift = 0;
        if (w <= s.width - 2 * pad) {
          if (cx - w / 2 < s.left + pad) {
            shift = s.left + pad - (cx - w / 2);
          } else if (cx + w / 2 > s.right - pad) {
            shift = s.right - pad - (cx + w / 2);
          }
        }
        tip.style.setProperty('--tip-shift', Math.round(shift / z) + 'px');
      }

      function closeAll() {
        spots.forEach(function (s) {
          s.classList.remove('is-open');
          var d = s.querySelector('[data-dot]');
          if (d) d.setAttribute('aria-expanded', 'false');
        });
        cards.forEach(function (c) { c.hidden = true; });
        open = null;
        refocus();
      }

      function openSpot(spot) {
        closeAll();
        var card = cardFor(spot);
        if (!card) return;
        place(card, spot);
        card.hidden = false;
        spot.classList.add('is-open');
        var d = spot.querySelector('[data-dot]');
        if (d) d.setAttribute('aria-expanded', 'true');
        open = spot;
        refocus();
      }

      function refocus() {
        var any = open || spots.some(function (s) { return s.classList.contains('is-hot'); });
        stage.classList.toggle('is-focused', !!any);
        items.forEach(function (item) {
          var sp = spotFor(item);
          item.classList.toggle('is-hot', !!sp && (sp.classList.contains('is-hot') || sp === open));
        });
      }

      spots.forEach(function (spot) {
        var dot = spot.querySelector('[data-dot]');

        // First tap opens the card; a second tap on the same piece goes to it.
        // A desktop double-click is two clicks, so it lands on the product too.
        spot.addEventListener('click', function (e) {
          if (e.target.closest('[data-scene-card]')) return;
          e.stopPropagation();
          if (open === spot) {
            window.location.href = spot.getAttribute('data-url');
          } else {
            openSpot(spot);
          }
        });

        spot.addEventListener('mouseenter', function () {
          fitTip(spot);
          spot.classList.add('is-hot');
          refocus();
        });
        spot.addEventListener('mouseleave', function () {
          spot.classList.remove('is-hot');
          refocus();
        });

        if (dot) {
          dot.addEventListener('focus', function () { fitTip(spot); spot.classList.add('is-hot'); refocus(); });
          dot.addEventListener('blur', function () { spot.classList.remove('is-hot'); refocus(); });
        }
      });

      // The legend (editorial layout): each line is the piece it names.
      items = Array.prototype.slice.call(scene.querySelectorAll('[data-legend-for]'));
      function spotFor(item) {
        var id = item.getAttribute('data-legend-for');
        for (var i = 0; i < spots.length; i++) {
          if (spots[i].getAttribute('data-spot') === id) return spots[i];
        }
        return null;
      }
      items.forEach(function (item) {
        var spot = spotFor(item);
        if (!spot) return;
        item.addEventListener('mouseenter', function () { fitTip(spot); spot.classList.add('is-hot'); refocus(); });
        item.addEventListener('mouseleave', function () { spot.classList.remove('is-hot'); refocus(); });
        item.addEventListener('focus', function () { fitTip(spot); spot.classList.add('is-hot'); refocus(); });
        item.addEventListener('blur', function () { spot.classList.remove('is-hot'); refocus(); });
        item.addEventListener('click', function (e) {
          e.stopPropagation();
          if (open === spot) {
            window.location.href = spot.getAttribute('data-url');
          } else {
            openSpot(spot);
          }
        });
      });

      cards.forEach(function (card) {
        card.addEventListener('click', function (e) { e.stopPropagation(); });
        var close = card.querySelector('[data-close]');
        if (close) {
          close.addEventListener('click', function (e) {
            e.stopPropagation();
            closeAll();
          });
        }
      });

      stage.addEventListener('click', function () { if (open) closeAll(); });
      document.addEventListener('click', function (e) {
        if (open && !stage.contains(e.target) && !e.target.closest('[data-scene-card]')) closeAll();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && open) closeAll();
      });

      // ?scenedebug=1 — read hotspot percentages off the picture.
      if (/[?&]scenedebug=1/.test(window.location.search)) {
        var out = stage.querySelector('[data-scene-debug]');
        stage.classList.add('is-debug');
        if (out) {
          out.hidden = false;
          out.textContent = 'click the picture for x / y %';
          stage.addEventListener('click', function (e) {
            var r = stage.getBoundingClientRect();
            var px = ((e.clientX - r.left) / r.width) * 100;
            var py = ((e.clientY - r.top) / r.height) * 100;
            out.textContent = 'x ' + px.toFixed(1) + '   y ' + py.toFixed(1);
          }, true);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
